import React from "react";
import Counter from "../Counter";
import { Box, Category, Details, ErrorText, SubTitle } from "./styled";

type ConfirmCounterProps = {
  title: string;
  subtitle?: string;
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  error?: string;
};

function ConfirmCounter({
  title,
  subtitle,
  value,
  onIncrement,
  onDecrement,
  error,
}: ConfirmCounterProps) {
  return (
    <Box>
      <Details>
        <Category>{title}</Category>
        <SubTitle>{subtitle}</SubTitle>
      </Details>
      <>
        <Counter
          value={value}
          onIncrement={onIncrement}
          onDecrement={onDecrement}
        />

        {error && <ErrorText>{error}</ErrorText>}
      </>
    </Box>
  );
}

export { ConfirmCounter };
